import * as Yup from "yup";

export const gateVoiceSchema = Yup.object().shape({
  name: Yup.string()
    .max(50, "cannot be > 50 characters")
    .required("Gate name is required"),
  type: Yup.string()
    .max(50, "cannot be > 50 characters")
    .required("Gate type is required"),
});
